module.exports = __webpack_public_path__ + "static/media/state.82bdf9cf.svg";